import { CityAccordion, type RegionType } from "@/pages/cities";

interface AllCitiesProps {
  regions: RegionType[];
}

export default function AllCities({ regions }: AllCitiesProps) {
  return (
    <section className="container pt-20 md:pt-[130px]">
      <h2 className="text-center font-semibold text-28/[1.5em] text-white md:text-48/[1.25em]">
        Find your next adventure in
        <br />
        <span className="text-berry">1,000+ cities</span>
      </h2>
      <CityAccordion regions={regions} />
    </section>
  );
}
